import ModalInput from "./ModalInput";

export * from "./ModalInput";

export default ModalInput;
